var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarningYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.836 11.152 9.012 1.2c-.465-.765-1.586-.765-2.024 0l-5.851 9.953a1.151 1.151 0 0 0 1.011 1.723h11.676c.903 0 1.45-.957 1.012-1.723zM7.344 4.344c0-.356.273-.657.656-.657.355 0 .656.301.656.657v3.5c0 .383-.3.656-.656.656a.665.665 0 0 1-.656-.656v-3.5zM8 11.125a.858.858 0 0 1-.875-.848c0-.464.383-.847.875-.847.465 0 .848.383.848.847a.852.852 0 0 1-.848.848z",
    fill: "#FA8C16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningYellow);
export default __webpack_public_path__ + "static/media/icon-warning-yellow.2e5d0c7eafcbaa30ee602c8ebfcc2b13.svg";
export { ForwardRef as ReactComponent };